import React, { useCallback, createRef, useEffect } from 'react';
import GettingStartedForm from './GettingStartedForm';
import GettingStartedSteps from './GettingStartedSteps';
import GettingStartedReason from './GettingStartedReason';
import GettingStartedFamily from './GettingStartedFamily/GettingStartedFamily';
import GettingStartedRooms from './GettingStartedRooms';
import GettingStartedServices from './GettingStartedServices';
import GettingStartedAddress from './GettingStartedAddress';
import { useDispatch, useSelector } from '../store';
import { gettingStartedSelector } from '../store/selectors';
import { prepareQuestionnaireData } from '../utils/data';

const GettingStarted = ({ form: formProps, rooms_options: roomsOptions, ...initialProps }) => {
  const dispatch = useDispatch();
  const {
    values: { reasons, rooms, services, family, address },
    form: formState,
    proPlatform,
  } = useSelector(gettingStartedSelector);
  const form = createRef();

  useEffect(() => {
    dispatch({ type: 'gettingStarted/update', payload: prepareQuestionnaireData(initialProps) });
  }, []);

  const handleReasonChange = useCallback(
    reason => {
      const newReasons = reasons.includes(reason)
        ? reasons.filter(r => r !== reason)
        : [...reasons, reason];
      dispatch({ type: 'gettingStarted/update', payload: { reasons: newReasons } });
    },
    [dispatch, reasons],
  );

  const handleRoomsChange = useCallback(
    room => {
      let newRooms = rooms.filter(r => r.type !== room.type);
      if (room.quantity > 0) {
        newRooms = [...newRooms, room];
      }
      dispatch({ type: 'gettingStarted/update', payload: { rooms: newRooms } });
    },
    [dispatch, rooms],
  );

  const handleServicesChange = useCallback(
    service => {
      const newServices = services.includes(service)
        ? services.filter(s => s !== service)
        : [...services, service];
      dispatch({ type: 'gettingStarted/update', payload: { services: newServices } });
    },
    [dispatch, services],
  );

  const handleFamilyChange = useCallback(
    (members, type) => {
      dispatch({ type: 'gettingStarted/update', payload: { family: { [type]: members } } });
    },
    [dispatch],
  );

  const handleAddressChange = useCallback(a => {
    dispatch({ type: 'gettingStarted/update', payload: { address: a } });
  }, []);

  const handleNext = useCallback(
    () => {
      if (form && form.current) {
        form.current.submit();
      }
    },
    [form],
  );

  return (
    <GettingStartedForm
      ref={form}
      {...formProps}
      values={{ reasons, rooms, services, family, address }}
    >
      <GettingStartedSteps
        invalid={[
          formState.reasonsInvalid,
          formState.familyInvalid,
          formState.roomsInvalid,
          formState.servicesInvalid,
          proPlatform ? formState.addressInvalid : false,
        ]}
        submitAction={proPlatform ? 'Submit' : 'Next question'}
        onNext={handleNext}
      >

        <GettingStartedReason
          value={reasons}
          proPlatform={proPlatform}
          onChange={handleReasonChange}
        />

        {proPlatform && (
          <GettingStartedFamily
            value={family}
            proPlatform={proPlatform}
            onChange={handleFamilyChange}
          />
        )}
        <GettingStartedRooms
          value={rooms}
          proPlatform={proPlatform}
          options={roomsOptions}
          onChange={handleRoomsChange}
        />
        <GettingStartedServices
          value={services}
          proPlatform={proPlatform}
          onChange={handleServicesChange}
        />
        {proPlatform && (
          <GettingStartedAddress
            value={address}
            proPlatform={proPlatform}
            onChange={handleAddressChange}
          />
        )}
      </GettingStartedSteps>
    </GettingStartedForm>
  );
};

export default GettingStarted;



// WEBPACK FOOTER //
// ./app/javascript/components/getting_started/components/GettingStarted.js